import type { ChannelProviderProps } from '../Channel/Context'
import { Channel } from '../Channel'
import { useConversationContext } from './Context'

// The conversation mount every Channel consumer shares — record-page cards render this as-is;
// the inbox thread supplies its own `components.layout` override through the `components` it
// already passes to ConversationProvider (ConversationDetail.tsx), so this stays the one
// provider tree instead of a second copy.
export const ConversationLayout = () => {
  const {
    conversationId,
    subject,
    rootUrl,
    recipient,
    components,
    members,
    sendChatMessageResult,
    middlewares,
    disabled,
  } = useConversationContext()

  const channelProps: Omit<ChannelProviderProps, 'children'> = {
    members,
    rootUrl,
    conversationId,
    subject,
    recipient,
    components,
    sendChatMessageResult,
    hooks: middlewares,
    disabled,
  }

  return <Channel {...channelProps} />
}
